import React from "react"

import style from "./intro.module.scss"
import Water from "./water"
import Image from "./image";
import SingleLineLogo from "./single-line-logo";

const Intro = () => {
    let [hoveredSentence, setHoveredSentence] = React.useState(1)

    React.useEffect(() => {
        setHoveredSentence(1)
        let timeoutId = setTimeout(() => {
            setHoveredSentence(2)
            timeoutId = setTimeout(() => {
                setHoveredSentence(3)
            }, 5000)
        }, 1000)
        return () => clearTimeout(timeoutId)
    }, [])

    let group = index => ({
        style: {
            transition: "opacity .5s ease-in-out", opacity: hoveredSentence >= index ? 1 : 0,
        },
    })
    const [lineDisplayed, setLineDisplayed] = React.useState(0)
    const [fade, setFade] = React.useState(1)

    function timeout(delay) {
        return new Promise(res => setTimeout(res, delay))
    }

    React.useEffect(() => {
        //Implementing the setInterval method
        const interval = setInterval(() => {
            setFade(0 )
            timeout(700).then(r => {
                setLineDisplayed((lineDisplayed + 1) % 2)
                setFade(1)
            })
        }, 5000)

        //Clearing the interval
        return () => clearInterval(interval)
    }, [lineDisplayed])

    let transition = index => ({
        style: {
            transition: "opacity .6s ease-in-out", opacity: index ? 1 : 0,
        },
    })

    const signatureLogoSize = {
        width: 100,
        height: 100,
        altText: "logo",
        url: "https://zj-v6.imgix.net/zj-content/ZJ-Logotype-Horizontal.svg"
    }


    let introLines = [<p>
        <div className="hidden-italic-preload">Loading…</div>
        <span className="h--serif-italic" {...group(2)}>
        Brands
      </span>{" "}
        <span className="underline" {...group(2)}>
        grow
      </span>{" "}
        <span  {...group(2)}>
        when
      </span>{" "}
        <span className="h--serif-italic" {...group(2)}>
        they
      </span>{" "}
        <span {...group(2)} className="underline" >mean</span>{" "}
        <span {...group(2)} className="underline" >more</span>{" "}
        <span  {...group(2)} className="h--serif-italic">
        to
      </span>{" "}
        <span className="h--serif-true-italic" {...group(2)}>
        the world.
      </span>
    </p>, <p>
        <span className={style.singleLineLogo} {...group(2)}>
            <SingleLineLogo></SingleLineLogo>
      </span>{" "}
        <span className="h--serif-italic" {...group(2)}>is the
      </span>{" "}
        <span className="underline" {...group(2)}>
        brand innovation
      </span>{" "}
        <span {...group(2)}>
        partner for
      </span>{" "}
        <span className="h--serif-true-italic" {...group(2)}>
            the
      </span>{" "}
        <span className="underline" {...group(2)}>
         world's best
      </span>{" "}

        <span className="h--serif-italic" {...group(2)}>brands.
      </span>{" "}
    </p>]

    return (<div className={style.intro}>
            <Water className={style.videoCanvas} stage={hoveredSentence}/>
            <div className={style.introText}>
                <div className="wrapper">
                    <div className="columns is-desktop">
                        <div className="column is-11-desktop">
                            <div className="h-display" {...transition(fade)}>
                                {introLines[lineDisplayed]}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
}

export default Intro
